import { Box, Typography } from '@mui/material';

import { popoverFilterMenuStyles as styles } from './popoverFilterMenu.styles';
import { AppIcon, FilterCategoryConfig } from '../..';

type SingleLayerFilterMenuProps = Readonly<{
  setAnchorEl: (anchorEl: HTMLElement | null) => void;
  categories: FilterCategoryConfig[];
  setSelectedCategory: (category: string | null) => void;
}>;

export const SingleLayerFilterMenu = ({
  setAnchorEl,
  categories,
  setSelectedCategory,
}: SingleLayerFilterMenuProps) => {
  return (
    <Box sx={styles.itemsContainerSx}>
      {categories.flatMap((category) =>
        category.items.map((item) => (
          <Box
            key={`${category.label}-${item.value}`}
            id={`filter-item-${item.value}`}
            sx={styles.filterItemSx}
            onClick={() => {
              item.onClick();
              if (item.closeOnClick) {
                setAnchorEl(null);
                setSelectedCategory(null);
              }
            }}
          >
            {item.icon && (
              <AppIcon
                iconName={item.icon}
                diameter="16px"
                color="Colors/Foreground/fg-quinary"
                strokeWidth="bold"
              />
            )}

            <Typography variant="text-sm-semibold" sx={styles.itemLabelSx}>
              {item.label}
            </Typography>

            {item.rightIcon ? (
              <AppIcon
                iconName={item.rightIcon}
                diameter="16px"
                color="Colors/Foreground/fg-quinary"
              />
            ) : (
              <Box sx={styles.checkboxSx}>
                <AppIcon
                  iconName="Check"
                  diameter="16px"
                  color={
                    item.isSelected ? 'Colors/Foreground/fg-quinary' : 'Colors/Base/Transparent'
                  }
                />
              </Box>
            )}
          </Box>
        )),
      )}
    </Box>
  );
};
